import { HistoryPurchase } from '../../interfaces/HistoryPurchase.interface';
import { Component, OnInit } from '@angular/core';
import { HistoryService } from '../../services/history.service';
import { Client } from '../../interfaces/Client.interface';
import { Product } from '../../interfaces/Product.interface';
import { TranslateService } from '@ngx-translate/core';
import { EnceService } from '../../services/ence.service';
declare var jQuery:any;
declare var $:any;


@Component({
  selector: 'app-history',
  templateUrl: './history.component.html',
  styleUrls: ['./history.component.css'],
  providers:[HistoryService,EnceService]
})
export class HistoryComponent implements OnInit {

  public purchasesSilvicolas: Array<any>;
  public pruchasesLudicos: Array<any>;
  public purchaseDetail: any;
  public purchaseDetailLud:any;
  public userInfo:any;
  public state:number;
  public filter:number;
  public limit:number;
  public textoResponse:string;
  public viewsilvicolas:boolean=false;
  public viewludicos:boolean=false;
  public viewDetail:boolean;

  public loaderPurchase:boolean;
  public lastId:any;
  public lastIdLud:any;

  constructor(
  private _historyService: HistoryService,
  private translate: TranslateService,
  public _enceService: EnceService
  ) {

    this.purchasesSilvicolas=[];
    this.pruchasesLudicos=[];
    this.purchaseDetail=[];
    this.purchaseDetailLud=[];

    this.state=0;
    this.filter=1;
    this.limit=1;
    this.viewDetail=false;

    this.loaderPurchase=false;
    this.lastId=0;
    this.lastIdLud=0;
  }

  ngOnInit() {

    if(localStorage.getItem('infoClient')){
      this.userInfo=JSON.parse(localStorage.getItem('infoClient'));
    }

    this.getPurchaseListSilvicolas();
    if(this.userInfo.category.id == '4'){
      this.getPurchaseListLudicos();
    }

  }


  /**
   * Funcion que carga el historico de pedidos
   */
  public getPurchaseListSilvicolas():void{
    this.viewsilvicolas=true;
     this._historyService.getPurchasesSilvicolas({
       idClient: this.userInfo.info.id,
       state: this.state,
       filter: this.filter,
       limit: this.limit
     }).subscribe(
       response => {
         if(response.empty===true){
          this.textoResponse=response.description;
          this.viewsilvicolas=false;
         }else{
          this.purchasesSilvicolas=response.purchases;
          this.viewsilvicolas=false;
         }

       },
       error => {
         console.error('Error en la petición '+error);
       }
     );
  }

  public getPurchaseListLudicos():void{
    this.viewludicos=true;
    this._historyService.getPurchasesLudicos({
      idClient: this.userInfo.info.id,
      state: this.state,
      filter: this.filter,
      limit: this.limit
    }).subscribe(
      response => {
        if(response.empty===true){
          this.textoResponse=response.description;
          this.viewludicos=false;
        }else{
          this.pruchasesLudicos=response.purchases;
          this.viewludicos=false;
        }
      },
      error => {
        console.error('Error en la petición '+error);
      }
    );
  }

  /**
   * Funcion que formatea el estado del pedido
   */
  public statePurchase(state):string{
    let format:string='';
    switch(state){
      case '0':
        format = this.translate.get('ence.history-status-new').toString();
      break;
      case '1':
      format=this.translate.get('ence.history-status-inProcess').toString();
      break;
      case '2':
      format = this.translate.get('ence.history-status-closed').toString();
       break;
      case '3':
      format = this.translate.get('ence.history-status-canceled').toString();
      break;
    }
    return format;
  }

  /**
   * View detail purchase
   */
  public viewDetailPurchaseSil(codpurchase){
    if(codpurchase == this.lastId){
      $('#sil'+codpurchase).toggle();
    }else if(this.lastId == 0){
      this._historyService.getDetailPurchase(codpurchase).subscribe(
        response => {
          this.purchaseDetail=response[0];
          $('#sil'+codpurchase).toggle(true);
        },
        error=>{
          console.error('Error en la petición '+error);
        }
      );
      this.lastId=codpurchase;
    }else if(codpurchase !== this.lastId && this.lastId !== 0){
      $('#sil'+this.lastId).toggle(false);
      this._historyService.getDetailPurchase(codpurchase).subscribe(
        response => {
          this.purchaseDetail=response[0];
        },
        error=>{
          console.error('Error en la petición '+error);
        }
      );
      $('#sil'+codpurchase).toggle(true);
      this.lastId=codpurchase;
    }
  }

  public viewDetailPurchaseLud(codpurchase){
    if(codpurchase == this.lastIdLud){
      $('#lud'+codpurchase).toggle();
    }else if(this.lastIdLud == 0){
      this._historyService.getDetailPurchase(codpurchase).subscribe(
        response => {
          this.purchaseDetailLud=response[0];
          $('#lud'+codpurchase).toggle(true);
        },
        error=>{
          console.error('Error en la petición '+error);
        }
      );
      this.lastIdLud=codpurchase;
    }else if(codpurchase !== this.lastIdLud && this.lastIdLud !== 0){
      $('#lud'+this.lastIdLud).toggle(false);
      this._historyService.getDetailPurchase(codpurchase).subscribe(
        response => {
          this.purchaseDetailLud=response[0];
        },
        error=>{
          console.error('Error en la petición '+error);
        }
      );
      $('#lud'+codpurchase).toggle(true);
      this.lastIdLud=codpurchase;
    }
  }


  /**
     * Funcion que nos dice si el usuario tiene permisos de propietario para el catalogo lúdico y mas datos
     */
    public havePermissions():boolean{
      if( this.userInfo.category.id == '4' && (this.userInfo.level.id == '10' || this.userInfo.level.id == '11' || this.userInfo.level.id == '12' || this.userInfo.level.id == '13')){
        return true;
      }else{
        return false;
      }
    }

  /**
   * Calcular puntos producto pedido
   */
  public calcScoreProducto(cant,score):number{
    let infoClient = JSON.parse(localStorage.getItem('infoClient'))
    let tot = parseInt(cant) * parseInt(score);
    if(infoClient.category.id == '4'){
        tot = parseInt(score) * 100;
    }else if(infoClient.category.id == '2'){
      tot = parseInt(score) / 7.8;
      tot = parseInt(tot.toFixed(2));
    }else{
      tot = score;
    }
    return tot;
  }

  public setId(codprod){
    return '#'+codprod;
  }

}
